<template>
    <div class="form-group">
        <label :for="name">{{label}}</label>
         <span class="text-danger" v-if="required">*</span>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true
            },

            name: {
                type: String,
                required: true
            },
            required: {
                type: Boolean,
                default: false
            }

        }
    };

</script>

<style>
</style>
